var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGitlab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 236,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 0 256 236",
    width: 256,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m128.07485 236.074667 47.104-144.9703622h-94.2080005z",
    fill: "#e24329"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m128.07485 236.074423-47.1040005-144.970362h-66.0150857z",
    fill: "#fc6d26"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m14.9558857 91.1044267-14.31405713 44.0551623c-1.3056 4.017981.12434286 8.419961 3.54255238 10.903161l123.89059005 90.012039z",
    fill: "#fca326"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m14.9558857 91.1045486h66.0150857l-28.3708952-87.31428574c-1.4592-4.49340953-7.8153143-4.49219048-9.2745143 0z",
    fill: "#e24329"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m128.07485 236.074423 47.104-144.970362h66.015085z",
    fill: "#fc6d26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m241.193935 91.1044267 14.314057 44.0551623c1.3056 4.017981-.124342 8.419961-3.542552 10.903161l-123.89059 90.012039z",
    fill: "#fca326"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m241.193935 91.1045486h-66.015085l28.370895-87.31428574c1.4592-4.49340953 7.815314-4.49219048 9.274514 0z",
    fill: "#e24329"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.fe53625cd2e37883b8f56fa3da3e64f5.svg";
export { ForwardRef as ReactComponent };